<template>
  <div class="main"><c-panel><form-component></form-component></c-panel></div>
</template>
<script>
import formComponent from "./form"
export default { components: { 'form-component': formComponent } }
</script>
